export const resources_mobile_vertical = {
    //sounds are loaded separately with super-mega-polished library which handles many different browsers starting even on loading stage:
    howler :
        [
            //
        ],
    //all other different resources (even those which configure the game logic) are able to be loaded with PIXI native loader:
    pixi :
        [
            "res/mobile_vertical/adaptiveBackground.jpg",
            "res/mobile_vertical/background_utility.png",

            {name: "res/mobile_vertical/mainbackground.png", rus: true},
            {name: "res/mobile_vertical/tables/forward.png", rus: true},
            {name: "res/mobile_vertical/tables/lose.png", rus: true},
            {name: "res/mobile_vertical/tables/win.png", rus: true},

            "res/mobile_vertical/fonts/font_points_mobile_vertical.xml",
            "res/mobile_vertical/fonts/font_bet_total_mobile_vertical.xml",
            "res/mobile_vertical/fonts/font_bet_up_mobile_vertical.xml",
            "res/mobile_vertical/fonts/font_bet_over_mobile_vertical.xml",
            "res/mobile_vertical/fonts/font_bet_down_mobile_vertical.xml",
            "res/mobile_vertical/fonts/font_score_mobile_vertical.xml",
            "res/mobile_vertical/fonts/font_credits_mobile_vertical.xml",
            "res/mobile_vertical/fonts/arial_black_10_mobile_vertical.xml",

            "res/mobile_vertical/cards.json",
            "res/mobile_vertical/uiscene_common.json",
            "res/mobile_vertical/skin_common.json",

            {name: "res/mobile_vertical/skin.json", rus: true},
            {name: "res/mobile_vertical/uiscene.json", rus: true},
        ]
};


//////////////////
// WEBPACK FOOTER
// ./res/mobile_vertical/resources.es6
// module id = 113
// module chunks = 0